// extracted by mini-css-extract-plugin
export default {"nav":"mobile-nav_nav__+GHdk","menu-item":"mobile-nav_menu-item__O5i5U","bottom":"mobile-nav_bottom__PWNAO"};